export default __webpack_public_path__ + "static/media/2.ff2cc4eb.jpg";